const handleMobileScroll = (currentScrollPosition) => {
  const actionBar = document.getElementById("action-bar");
  const notificationsBar = document.getElementById("navbar");
  const tabNav = document.getElementById("tab-nav");
  const mobileBottomNav = document.getElementById("mobile-bottom-nav");
  const editCandidateRecord = document.getElementById("edit-candidate-record");
  const employerAnalyticsFilters = document.getElementById(
    "employer-analytics-filters"
  );

  // window handle scroll directions
  if (window.scrollY > currentScrollPosition) {
    if (actionBar) actionBar.classList.add("downScroll");
    if (notificationsBar) notificationsBar.classList.add("downScroll");
    if (editCandidateRecord) editCandidateRecord.classList.add("downScroll");
    if (tabNav) tabNav.classList.add("downScroll");
    if (employerAnalyticsFilters)
      employerAnalyticsFilters.classList.add("downScroll");
  }

  if (window.scrollY < currentScrollPosition) {
    if (actionBar) actionBar.classList.remove("downScroll");
    if (notificationsBar) notificationsBar.classList.remove("downScroll");
    if (tabNav) tabNav.classList.remove("downScroll");
    if (editCandidateRecord) editCandidateRecord.classList.remove("downScroll");
    if (employerAnalyticsFilters)
      employerAnalyticsFilters.classList.remove("downScroll");
  }

  // handle iOS pull down in Safari to show navbar/action bar/bottom navbar
  let overscroll;

  window.addEventListener("touchstart", () => {
    overscroll = false;
  });

  window.addEventListener("touchend", () => {
    if (document.body.scrollTop < 0) {
      overscroll = true;
    }
  });

  window.addEventListener("scroll", () => {
    if (overscroll && document.body.scrollTop === 0) {
      overscroll = false;

      if (notificationsBar) notificationsBar.classList.remove("downScroll");
      if (actionBar) actionBar.classList.remove("downScroll");
      if (mobileBottomNav) mobileBottomNav.classList.add("upScroll");
    }
  });
};

export { handleMobileScroll as default };
